<template>
  <header class="provider_show_header">
    <button
      type="button"
      class="provider_show_header__logo"
      :disabled="!logo"
      @click="$emit('preview', logo)"
    >
      <img v-if="logo" loading="lazy" :src="logo" alt="logo" />
      <span v-else class="provider_show_header__logo_placeholder">
        <i class="fas fa-store"></i>
      </span>
    </button>

    <div class="provider_show_header__content">
      <h3>{{ nameAr || "-" }}</h3>
      <p>{{ nameEn || "-" }}</p>
      <span
        class="provider_show_badge"
        :class="isActive ? 'is_active' : 'is_inactive'"
      >
        {{ isActive ? $t("PLACEHOLDERS.active") : $t("PLACEHOLDERS.notActive") }}
      </span>
    </div>
  </header>
</template>

<script>
export default {
  name: "ProviderShowHeader",
  props: {
    logo: { type: String, default: null },
    nameAr: { type: String, default: null },
    nameEn: { type: String, default: null },
    isActive: { type: [Boolean, Number], default: true },
  },
};
</script>
